import { FC, useRef } from 'react';
import cx from 'classnames';
import { useOnClickOutside } from '@/hooks';
import { RiskType } from '@/models';
import { getSignalTranslation } from '@/helpers';

import styles from './RiskDetailsInfoPopup.module.sass';

interface RiskDetailsInfoPopupProps {
  type: RiskType;
  value: number;
  price: string;
  label?: string;
  className?: string;
  parentRef?: React.RefObject<HTMLElement>;
  onClose: () => void;
}

const RiskDetailsInfoPopup: FC<RiskDetailsInfoPopupProps> = ({
  type,
  value,
  price,
  label,
  className,
  parentRef,
  onClose,
}) => {
  const panelRef = useRef<HTMLDivElement>(null);
  const classes = cx(styles.popup, styles[`popup--${type}`], className);

  useOnClickOutside([panelRef], onClose, parentRef, []);

  const signalTitle = label ? getSignalTranslation(label) : '';

  return (
    <div className={classes} ref={panelRef}>
      <div className={styles.value}>{value}%</div>
      {label && <div className={styles.title}>{signalTitle}</div>}
      {price && (
        <>
          <div className={styles.label}>Amount at risk</div>
          <div className={styles.price}>
            <span>{price}</span>&nbsp;•&nbsp;
          </div>
        </>
      )}
      {label && (
        <div className={styles.description}>
          {getSignalTranslation(label, 'src_')}
        </div>
      )}
    </div>
  );
};

export default RiskDetailsInfoPopup;
